<div [ngStyle]="setTitleStyle()" class="modal-header sm-header" >
    <span class="confirmationText" >{{ title }}</span>
      <button type="button" class="close modal-sm" (click)="decline()" [style.display]="showDisplay()">&times;</button>  
    </div>
    <div class="modal-body modal-body-med">
     <div class="messageText" [innerHTML]="message">  </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="clickBtn" (click)="accept()">{{ btnOkText }}</button>
      <button type="button" *ngIf="btnCancelShow" class="clickBtn" (click)="decline()">{{ btnCancelText }}</button>   
    </div>